import * as React from 'react';
import { CaretDown, CaretUp } from '@liveauctioneers/hammer-ui-core/icons';
import { Collapse } from 'react-collapse';
import { H5 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';

type Props = {
    children: React.ReactNode;
    className?: string;
    closeFacet?: boolean;
    header?: React.ReactNode;
    hideExpandCollapse?: boolean;
    hideTitle?: boolean;
    testid?: string;
    title: React.ReactNode;
};

const Facet = ({
    children,
    className = '',
    closeFacet = false,
    header,
    hideExpandCollapse = false,
    hideTitle = false,
    testid,
    title,
}: Props): ReactElement<Props> => {
    const [isClosed, setIsClosed] = useState(closeFacet);

    useEffect(() => {
        setIsClosed(closeFacet);
    }, [closeFacet]);

    const handleClick = () => {
        setIsClosed(!isClosed);
    };

    return (
        <StyledFacet
            className={className}
            data-testid={testid}
        >
            {!hideTitle && !hideExpandCollapse && (
                <StyledTitleBar
                    data-testid={testid + 'Title'}
                    onClick={handleClick}
                >
                    {!hideTitle && <StyledTitle>{title}</StyledTitle>}
                    {!hideExpandCollapse && (
                        <>
                            {isClosed ? (
                                <CaretDown
                                    size="xs"
                                    style="fill"
                                />
                            ) : (
                                <CaretUp
                                    size="xs"
                                    style="fill"
                                />
                            )}
                        </>
                    )}
                </StyledTitleBar>
            )}
            <Collapse isOpened={!isClosed}>
                <StyledPanel>
                    {header}
                    {children}
                </StyledPanel>
            </Collapse>
        </StyledFacet>
    );
};

export default Facet;

const StyledFacet = styled.section`
    padding-top: 0;
    padding-bottom: 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.grey400};

    &:last-child {
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey400};
    }
`;

const StyledTitleBar = styled.div`
    margin-bottom: -16px;
    padding: 16px 4px 16px 0;
    line-height: 17px;
    letter-spacing: 1px;
    color: ${({ theme }) => theme.colors.grey100};
    font-style: normal;
    font-stretch: normal;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`;

const StyledTitle = styled(H5)`
    color: ${({ theme }) => theme.colors.steel};
    user-select: none;
`;

const StyledPanel = styled.div`
    border: none;
    box-shadow: none;
    margin-bottom: 0;
    padding: 16px 0 0 0;
`;
